import { BlobSasModel, PhotoModel } from "@common/models";
import { ISendSMSResponseModel, SendSMSResponseModel } from "@common/models/SendSMSResponseModel";
import { ISmsModel } from "@common/models/SmsModel";
import { ServiceHelper } from "@common/services/serviceHelper";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class SmsService {
  private static baseUrl: string = "/api/textmessage/";

  public static tags = {
    validatePhoneNumber: "validatePhoneNumber",
    sendSms: "sendSms",
    uploadPhoto: "uploadPhoto"
  };

  static validateSms = (model: ISmsModel): Promise<void> => {
    return trackPromise(
      new Promise<void>((resolve, reject) => {
        http(`${this.baseUrl}validate`)
          .post<void>(model)
          .then(() => resolve())
          .catch(() => reject());
      }),
      ServiceHelper.getTagForOptions(this.tags.validatePhoneNumber)
    );
  };

  static send = (model: ISmsModel): Promise<SendSMSResponseModel> => {
    return trackPromise(
      new Promise<SendSMSResponseModel>((resolve, reject) => {
        http(`${this.baseUrl}send`)
          .post<ISendSMSResponseModel>(model)
          .then(json => resolve(new SendSMSResponseModel(json)))
          .catch(reject);
      }),
      ServiceHelper.getTagForOptions(this.tags.sendSms)
    );
  };

  static uploadPhoto = (model: BlobSasModel): Promise<PhotoModel> => {
    return trackPromise(
      new Promise<PhotoModel>((resolve, reject) => {
        http(`${this.baseUrl}photo`)
          .post<PhotoModel>(model)
          .then(resolve)
          .catch(reject);
      }),
      ServiceHelper.getTagForOptions(this.tags.uploadPhoto)
    );
  };
}
